import { RoomKey } from '../socket.room.key';

export interface ExtensionAgentChangedMessage {
    type: 'definition_changed' | 'assignment_changed';
    agentId: string;
    revision: number;
}

export const ExtensionAgentRooms = {
    extensionAgents: (): RoomKey<ExtensionAgentChangedMessage> => ({ key: 'extension-agents' }),
};
